<!--  -->
<template>
  <header class="header box-shadow" ref="header">
    <div class="header-nav">
      <div class="nav-logo">
        <!-- <img src="../assets/images/logo.png" alt=""> -->
      </div>
      <div class="header-menu">
        <div class="nav-menu">
          <ul
            class="sub-menu"
            id="sub-menu"
            ref="sub-menu"
            @mouseover="mouseover"
            @mouseleave="mouseleave"
          >
            <li class="sub-menu-item">
              <a href="/home/"><span>Home</span></a>
            </li>
            <li
              class="sub-menu-item has-sub"
              data-route="/data"
              :class="[currentActive == '/data' ? 'menu-active' : '']"
            >
              <a>
                <span>Data<i class="el-icon-arrow-down"></i> </span>
                <ul class="sub-menu-item-sub">
                  <li class="sub-menu-item" data-route="/data">
                    <a @click="routerTo('/explor')">
                      <i class="icon explor"></i>
                      <span>Exploration</span>
                    </a>
                  </li>
                  <li class="sub-menu-item" data-route="/data">
                    <a to="/glossary" @click="routerTo('/glossary')">
                      <i class="icon gloss"></i
                      ><span>Anatomical Glossaries</span>
                    </a>
                  </li>
                  <!-- <li class="sub-menu-item" data-route="/data">
                  <router-link to="/report"><i class="icon report"></i><span>Report</span></router-link>
                </li> -->
                  <li class="sub-menu-item" data-route="/data">
                    <a to="/download" @click="routerTo('/download')"
                      ><i class="icon download"></i><span>Download</span></a
                    >
                  </li>
                  <li class="sub-menu-item" data-route="/data">
                    <a to="tibet-plateau" @click="routerTo('/tibet-plateau')"
                      ><i class="icon tibet_plateau"></i
                      ><span>Tibet Plateau</span></a
                    >
                  </li>
                  <!-- <li class="sub-menu-item" data-route="/data">
                    <a href="/biodiversity/"
                      ><i class="icon biodiversity"></i
                      ><span>Biodiversity</span></a
                    >
                  </li> -->
                </ul>
              </a>
            </li>
            <!-- <li class="sub-menu-item">
              <a href="/publication/">
                <span>Publication</span>
              </a>
            </li> -->
            <li
              class="sub-menu-item has-sub"
              data-route="/about"
              :class="[currentActive == '/about' ? 'menu-active' : '']"
            >
              <a>
                <span>About<i class="el-icon-arrow-down"></i></span>
                <ul class="sub-menu-item-sub">
                  <li class="sub-menu-item" data-route="/about">
                    <a to="/people" @click="routerTo('/people')"
                      ><i class="icon people"></i><span>People</span></a
                    >
                  </li>
                  <li class="sub-menu-item" data-route="/about">
                    <a to="/funding" @click="routerTo('/funding')"
                      ><i class="icon funding"></i><span>Funding</span></a
                    >
                  </li>
                  <li class="sub-menu-item" data-route="/about">
                    <a to="/about/faq" @click="routerTo('/about/faq')"
                      ><i class="icon faq"></i><span> FAQ</span></a
                    >
                  </li>
                </ul>
              </a>
            </li>
          </ul>
        </div>
        <!-- <el-button v-if="isDark" type="primary" size="small" style="float:right;margin-top:13px;margin-left:5px;background: #F05A27;color: white;border-color:#F05A27" class="dark-style" @click="changeStyle(false)">风格切换</el-button>
        <el-button v-else type="primary" size="small" style="float:right;margin-top:13px;margin-left:5px;background: #72c2c9;color: white;border-color:#72c2c9" class="common-style" @click="changeStyle(true)">风格切换</el-button> -->
        <div class="nav-search">
          <v-search></v-search>
          <!-- <div class="user-menu">
          <router-link to="/user">
            <img class="avatar" :src="avatar" alt="">
          </router-link>
        </div> -->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import VSearch from "./search.vue";
import VUser from "./user.vue";
export default {
  name: "v-header",
  components: {
    VSearch,
    VUser,
  },
  data() {
    return {
      explor: require("../assets/images/explor.png"),
      avatar: require("../assets/images/avatar.png"),
      currentActive: "",
      elHeader: null,
      menu: null,
      isDark: false,
    };
  },
  computed: {
    // defaultActive() {
    //   let pathSplit = this.currentActive.split("/");
    //   pathSplit.shift();
    //   let route = "/" + pathSplit.splice(0, 2).join("/");
    //   return route;
    // },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      this.menu = this.$refs["sub-menu"];
      this.elHeader = this.$refs["header"];
    });
  },
  methods: {
    routerTo(path, other) {
      this.removeClass(this.elHeader, "open");
      let currentPath = this.$route.path;
      let params = JSON.stringify(this.$route.params);
      let query = JSON.stringify(this.$route.query);
      let currentOther = JSON.stringify(other);
      if (
        currentPath == path &&
        (params == currentOther || query == currentOther)
      ) {
        return;
      }
      this.$router
        .push({
          path: path,
          // query: query,
        })
        .then((res) => {
          // this.$router.go(0);
        });
    },
    changeStyle(value) {
      localStorage.setItem("dark-style", value);
      this.$router.go(0);
    },
    mouseover(event) {
      let target = event.target;
      let sub = this.hasSub(target);
      if (sub) {
        this.addClass(this.elHeader, "open");
        this.removeAllClass("hover");
        let arrow = sub.querySelector(".el-icon-arrow-down");
        if (arrow) {
          this.addClass(arrow, "hover");
        }
      } else {
        this.removeClass(this.elHeader, "open");
        this.removeAllClass("hover");
      }
    },
    addClass(el, className) {
      el.classList.add(className);
    },
    removeClass(el, className) {
      el.classList.remove(className);
    },
    removeAllClass(className) {
      let arrows = document.querySelectorAll("." + className);
      arrows.forEach((el) => {
        this.removeClass(el, className);
      });
    },
    hasSub(target) {
      while (target.tagName != "BODY") {
        if (target.classList.contains("has-sub")) {
          return target;
        }
        target = target.parentNode;
      }
      return false;
    },
    mouseleave(event) {
      //   this.currentActive = "";
      //   let arrows = document.querySelectorAll(".el-icon-arrow-down.hover");
      //   arrows.forEach((arrow) => {
      //     arrow.classList.remove("hover");
      //   });
      this.removeClass(this.elHeader, "open");
      this.removeAllClass("hover");
    },
  },
  watch: {
    $route: function (val) {
      this.currentActive = "";
      // let isDark = localStorage.getItem("dark-style") == "yes" ? true : false;
      //   let queryDark = val.query["dark-style"];
      //   if (queryDark == "yes") {
      //     this.isDark = true;
      //     localStorage.setItem("dark-style", "yes");
      //   } else {
      //     this.isDark = false;
      //     localStorage.removeItem("dark-style");
      //   }
      //   if (this.isDark != isDark) {
      //     this.$router.go(0);
      //   }
      let style = localStorage.getItem("dark-style");
      let queryDark = val.query["dark-style"];
      if (queryDark == "yes") {
        this.isDark = true;
        localStorage.setItem("dark-style", "yes");
      } else if (queryDark == "no") {
        this.isDark = false;
        localStorage.setItem("dark-style", "no");
      } else {
        // //dark-style undefined
        if (style == "yes") {
          this.isDark = true;
        } else if (style == "no") {
          this.isDark = false;
        } else {
          this.isDark = false;
        }
      }
      style = style == "yes" ? true : false;
      if (this.isDark != style) {
        this.$router.go(0);
      }
    },
  },
};
</script>
<style>
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  min-width: 1000px;
  height: 60px;
  background: rgba(255, 255, 255, 0.6);
  padding: 0 47px;
  transition: height 0.3s;
  overflow: hidden;
}
.header.open {
  height: 140px;
  /* background: rgba(255, 255, 255, 0.6); */
  background: white;
}
.header-nav {
  height: 60px;
}
.nav-logo {
  float: left;
  width: 100px;
  height: 100%;
  line-height: 60px;
  background: url("../assets/images/logo.png");
  background-repeat: no-repeat;
  background-size: 100px 24px;
  background-position: center center;
}
.nav-logo img {
  width: 100%;
  vertical-align: middle;
  background-size: 100% 100%;
}
.header-menu {
  float: right;
  width: calc(100% - 100px);
}
.nav-menu {
  max-width: calc(100% - 377px);
  min-width: 200px;
  height: 60px;
  overflow: hidden;
  float: left;
}
.nav-menu .sub-menu {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.nav-menu .sub-menu-item {
  padding: 0 20px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}
.nav-menu .sub-menu .sub-menu-item a {
  display: inline-block;
  width: 100%;
  color: #484d63;
}
.sub-menu-item a > .icon {
  display: inline-block;
  width: 39px;
  height: 39px;
  vertical-align: middle;
  background: rgba(24, 156, 169, 0.6);
  /* mix-blend-mode: darken; */
  border-radius: 4px;
  background-size: 25px;
  background-position: center center;
  background-repeat: no-repeat;
}
.sub-menu-item a > .explor {
  background-image: url("../assets/images/explor.png");
}
.sub-menu-item a > .gloss {
  background-image: url("../assets/images/gloss.png");
}
.sub-menu-item a > .report {
  background-image: url("../assets/images/report.png");
}
.sub-menu-item a > .download {
  background-image: url("../assets/images/cloud-download.png");
}
.sub-menu-item a > .biodiversity {
  background-image: url("../assets/images/biodiversity.png");
  background-size: 20px;
}
.sub-menu-item a > .tibet_plateau {
  background-image: url("../assets/images/tibet_plateau.png");
  background-size: 32px;
}
.sub-menu-item a > .people {
  background-image: url("../assets/images/people.png");
}
.sub-menu-item a > .funding {
  background-image: url("../assets/images/funding.png");
}
.sub-menu-item a > .faq {
  background-image: url("../assets/images/faq.png");
}

.nav-menu .sub-menu a ul {
  /* display: none; */
  width: 100%;
}
.sub-menu-item-sub {
  position: absolute;
  left: 0;
  top: 60px;
  height: 80px;
  padding: 0 47px;
  display: flex;
  align-items: center;
  flex: 1;
}
.sub-menu-item-sub .sub-menu-item {
  /* width: 234px; */

  /* mix-blend-mode: darken; */
  border-radius: 4px;
  margin-right: 15px;
}
.sub-menu-item-sub .sub-menu-item:hover {
  background: rgba(196, 196, 196, 0.6);
  /* background: #c4c4c4; */
}
.nav-search {
  height: 60px;
  float: right;
  /* width: 277px;暂时隐藏用户部分，如果开放用户部分，这段代码需要显示 */
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.user-menu {
  width: 40px;
  margin-left: 12px;
}
.user-menu a {
  display: inline-block;
  width: 100%;
}
.user-menu .avatar {
  width: 100%;
}
.sub-menu-item span {
  padding: 5px 10px;
  font-weight: 600;
}

.sub-menu-item span i {
  margin-left: 8px;
  transition: transform 0.3s;
}
.menu-active > a > span {
  background-color: rgba(196, 196, 196, 0.6) !important;
  border-radius: 4px !important;
}
.sub-menu-item span i.hover {
  /* animation: rotation 1s forwards; */
  transform: rotate(180deg);
}
.sub-menu-item-sub {
  display: none;
}
.nav-menu .sub-menu-item:hover .sub-menu-item-sub {
  display: flex;
}
</style>
